import React from "react";
import { Box, Stack, TableCell, TableRow, Typography } from "@mui/material";

import UserChip from "../../../components/chips/user-chip";
import StatusChip from "../../../components/chips/status-chip";
import { useListUsers } from "../../../store";
import { Client, ClientType, UserType } from "../../../types";
import { ClientAvatar } from "../../../components/avatars";
import ClientChip from "../../../components/chips/client-chip";

type AdminClientsTableRowProps = {
  client: Client;
  onSelect?: (client: Client) => void;
  selected?: boolean;
};

const AdminClientsTableRow: React.FC<AdminClientsTableRowProps> = ({
  client,
  onSelect,
  selected = false,
}) => {
  const { data: users = [] } = useListUsers(true, client.clientId);

  const adminUsers = React.useMemo(
    () =>
      users
        .filter((user) => user.userType === UserType.SysAdmin)
        .sort((a, b) =>
          (a.fullName || a.email || "Unknown user").localeCompare(
            b.fullName || b.email || "Unknown user",
          ),
        ),
    [users],
  );

  return (
    <TableRow
      sx={{
        cursor: "pointer",
        backgroundColor: selected ? "rgba(5, 84, 128, 0.08)" : undefined,
        "&:hover": {
          background:
            "linear-gradient(135deg, rgba(5, 84, 128, 0.08) 0%, rgba(0, 150, 136, 0.08) 100%)",
        },
      }}
      onClick={() => onSelect?.(client)}
    >
      <TableCell sx={{ py: 1, whiteSpace: "nowrap" }}>
        <ClientChip
          clientId={client.clientId}
          name={client.clientName}
        />
      </TableCell>
      <TableCell sx={{ py: 1, whiteSpace: "nowrap" }}>
        <StatusChip
          status={client.type || ClientType.Inactive}
          size="small"
          height="18px"
          fontSize="0.7rem"
        />
      </TableCell>
      <TableCell sx={{ py: 1, whiteSpace: "nowrap" }}>
        <Typography variant="body2" color="text.secondary">
          {client.created
            ? new Date(client.created).toLocaleDateString("en-AU")
            : "N/A"}
        </Typography>
      </TableCell>
      <TableCell sx={{ py: 1, width: "100%" }}>
        {adminUsers.length > 0 ? (
          <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
            {adminUsers.map((user) => (
              <UserChip
                key={user.userId}
                name={user.fullName || user.email || "Unknown user"}
              />
            ))}
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary">
            None
          </Typography>
        )}
      </TableCell>
      <TableCell align="right" sx={{ py: 1, whiteSpace: "nowrap" }}>
        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
          <Box
            sx={{
              px: 1,
              background: "#e6e6e6",
              borderRadius: 1,
            }}
          >
            <Typography variant="caption">TODO</Typography>
          </Box>
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export default AdminClientsTableRow;
